import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import ParameterStructure from "../parameter/structure/ParameterStructure";
import styles from "./Canvas.module.scss";
import CanvasElementButton from "./CanvasElementButton";
import CanvasElementPanel from "./CanvasElementPanel";

export function Canvas({ node, isGlobal, isResizable }) {
  return (
    <div
      className={`${styles["canvas__main"]}  ${isResizable ? styles["canvas__main--resizable"] : ""}`}>
      <Elements isResizable={isResizable}>
        <ElementParameters node={node} />
        <CanvasElementPanel node={node} />
        <CanvasElementButton node={node} isGlobal={isGlobal} />
      </Elements>
    </div>
  );
}

const Elements = ({ isResizable, children }) => {
  return <div className={`${styles["canvas__elements"]}`}>{children}</div>;
};

const ElementParameters = ({ node }) => {
  if (!node) {
    return null;
  }

  const _parameters = nodeUtils.getParameters(node);

  const _rows = [];

  for (let i = 0; i < _parameters.length; i++) {
    _rows.push(
      <div className={styles["canvas__elements-parameter"]} key={nodeUtils.getUUID(_parameters[i])}>
        <ParameterStructure
          node={{
            current: _parameters[i],
            previous: i > 0 ? _parameters[i - 1] : null,
            next: i < _parameters.length - 1 ? _parameters[i + 1] : null,
            top: node,
          }}
          position={{
            index: i,
            isFirst: i === 0,
            isOneBeforeLast: i === _parameters.length - 2,
            isLast: i === _parameters.length - 1,
            isNested: false,
          }}
          readOnly={false}
        />
      </div>
    );
  }

  return _rows;
};
